/**
 * Created by hp on 2017/8/21.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {Button} from 'react-weui';
import { toLecture } from '../../utils/connectApp'


class RelaySettingListItem extends Component {
    constructor() {
        super();
        this.handleCancelRelay = this.handleCancelRelay.bind(this);
        this.handleLink = this.handleLink.bind(this);
    }

    handleCancelRelay(e) {
        const {relaiers, relayType} = this.props;

        let relayId = parseInt(e.target.dataset.id, 10);
        let newRelaiers = [];
        this.context.page.showConfirm('温馨提示', '确定要解除该转载间', () => {
            axios.post(`/api/relay/${relayType}/${relayId}/cancel_relay`).then(res => {
                if (res.data.code === 0) {
                    newRelaiers = relaiers.filter((item) => {
                        return item.id !== relayId;
                    });
                    this.props.dispatch({type: 'RELAY_SETTING_LIST_CANCEL_RELAY', payload: newRelaiers});
                }
            });
        });
    }

    handleLink(e) {
        const {relayType} = this.props;
        const id = e.target.dataset.id || e.currentTarget.dataset.id;
        const mode = e.target.dataset.mode || e.currentTarget.dataset.mode;

        if (relayType === 'channel') {
            if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())){
                window.location = `lizhiweike://channel?channel_id=${id}`
            }else {
                window.location = `/channel/${id}`
            }
        }

        if (relayType === 'lecture') {
            if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())){
                toLecture({ id: id, lectureMode: mode })
            }else {
                window.location = `/lecture/${id}`
            }
        }
    }

    render() {
        const {relayer, isEnd} = this.props;

        return(
            <div className={"relay-setting-list-item wk-border-line-before " + (isEnd ? "wk-border-line-after" : "")}>
                <div className="rly-img" data-id={relayer.id} data-mode={relayer.lecture_mode} onClick={this.handleLink}>
                    <img src={relayer.liveroom.small_avatar_url}/>
                </div>
                <div className="rly-title" data-id={relayer.id} data-mode={relayer.lecture_mode} onClick={this.handleLink}>
                    <p className="intro-title">{relayer.liveroom.name}</p>
                    <p className="intro-dec">预约：{relayer.subscribe_count}</p>
                </div>
            </div>
        )
    }
}

RelaySettingListItem.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    relaiers: state.relaySetting.relaiers
}))(RelaySettingListItem)



// WEBPACK FOOTER //
// ./src/components/relaySetting/RelaySettingListItem.js